const SimplePageHeading: React.FC<{ title: string; description?: string }> = ({ title, description }) => {
  return (
    <div className=" py-2 pl-2">
      <h3 className="text-base font-semibold leading-6 text-gray-900">{title}</h3>
      {description && <p className="mt-2 max-w-4xl text-sm text-gray-500">{description}</p>}
    </div>
  );
};

export default SimplePageHeading;
